import { render } from "./UpdateProduct.vue?vue&type=template&id=13c5874a&scoped=true"
import script from "./UpdateProduct.vue?vue&type=script&lang=js"
export * from "./UpdateProduct.vue?vue&type=script&lang=js"

import "./UpdateProduct.vue?vue&type=style&index=0&id=13c5874a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13c5874a"]])

export default __exports__